module.exports = __webpack_public_path__ + "img/tool_icon3.2ca058e9.svg";